export default {
  common: {
    about: 'About',
    agreed: 'Agreed',
    all: 'All',
    back: 'Back',
    backToTop: 'Back to top',
    cancel: 'Cancel',
    close: 'Close',
    comment: 'Comment | Comments',
    create: 'Create',
    created: 'Created',
    createdAt: 'Created at',
    date: 'Date',
    dateRange: 'Date Range',
    description: 'Description',
    disputed: 'Disputed',
    distance: 'Distance',
    download: 'Download',
    edit: 'Edit',
    edited: 'Edited',
    email: 'Email',
    enabled: 'enabled',
    error: 'Error',
    example: 'Example',
    expired: 'Expired',
    failed: 'Failed',
    file: 'File',
    filter: 'Filter',
    filters: 'Filters',
    for: 'For',
    full: 'Full',
    half: 'Half',
    home: 'Home',
    id: 'Id',
    jobNo: 'Job No',
    loading: 'Loading',
    name: 'Name',
    no: 'No',
    none: 'None',
    notes: 'Notes',
    null: 'Null',
    ok: 'OK',
    open: 'Open',
    password: 'Password',
    price: 'Price',
    processed: 'Processed',
    protection: 'Protection',
    quantity: 'Quantity',
    raw: 'Raw',
    remove: 'Remove',
    reset: 'Reset',
    result: 'Result | Results',
    search: 'Search',
    settings: 'Settings',
    sortBy: 'Sort by',
    status: 'Status',
    submit: 'Submit',
    supplier: 'Supplier | Suppliers',
    surcharge: 'Surcharge',
    time: 'Time',
    title: 'Title',
    total: 'Total',
    unknown: 'Unknown',
    updated: 'Updated',
    updatedAt: 'Updated at',
    upload: 'Upload',
    user: 'User',
    username: 'Username',
    users: 'Users',
    weight: 'Weight',
    yes: 'Yes',
  },
}
